import React from 'react'
import { Type_WeekRange } from 'typescript/types'
import dayjs from "dayjs"
export const WeekSelected: React.FC<{selectedWeekRange: Type_WeekRange & {weekNumber: number, date: string}}> = ({selectedWeekRange}) => {
  return (
    <p style={{fontWeight: 600}} className="text-[16px] leading-[18px] text-primary font-semibold">{dayjs(selectedWeekRange.from).format("MMM D")} - {dayjs(selectedWeekRange.to).format("MMM D")}</p>
  )
}
